import type { Dict } from './vi'

export const en: Dict = {
  brand: {
    name: 'Moc',
    tagline: 'Real Estate Marketplace',
  },
  menu: {
    windowsOpen: '{count} windows open',
    langVi: 'Tiếng Việt',
    langEn: 'English',
  },
  apps: {
    market: 'Market',
    compare: 'Compare',
    manage: 'Manage Listings',
    manageShort: 'Manage',
    loan: 'Loan Calculator',
    account: 'Account',
  },
  market: {
    buy: 'For Sale',
    rent: 'For Rent',
    searchPlaceholder: 'Search by address, project, keyword...',
    allProvinces: 'All provinces',
    allDistricts: 'All districts',
    allTypes: 'All property types',
    filters: 'Filters',
    reset: 'Reset',
    sort: 'Sort',
    sortNewest: 'Newest',
    sortPriceAsc: 'Price low → high',
    sortPriceDesc: 'Price high → low',
    sortAreaDesc: 'Largest area',
    sortPriceM2Asc: 'Lowest price / m²',
    resultsCount: '{count} properties',
    noResults: 'No matching properties found',
    clearFilters: 'Clear filters',
    only360: 'Only 360° / VR virtual tour',
    onlyVerified: 'Only verified properties',
    bedrooms: 'Bedrooms',
    priceRange: 'Price range',
    areaRange: 'Minimum area',
    amenities: 'Key amenities',
    save: 'Save',
    saved: 'Saved',
    compare: 'Compare',
    contact: 'Contact',
    details: 'View details',
  },
  common: {
    close: 'Close',
    cancel: 'Cancel',
    save: 'Save',
    copied: 'Link copied to clipboard',
    search: 'Search',
  },
}
